import { Button, Flex } from '@components';
import { styled } from '@mui/material';

export const StyledContainer = styled(Flex)(({ theme }) => ({
  flex: 1,
  padding: theme.spacing(12, 13),
  flexDirection: 'column',
}));

export const StyledGiftImage = styled('img')(({ theme }) => ({
  width: theme.spacing(18),
  height: theme.spacing(18),
  objectFit: 'contain',
  [theme.breakpoints.down('md')]: {
    width: 42,
    height: 42,
  },
  [theme.breakpoints.down('sm')]: {
    width: theme.spacing(17),
    height: theme.spacing(17),
  },
}));

export const ReferralContainer = styled(Flex)(({ theme }) => ({
  flexDirection: 'column',
  alignSelf: 'flex-start',
  [theme.breakpoints.down('md')]: {
    alignSelf: 'auto',
  },
}));

export const StyledReferralInfoContainer = styled(Flex)(({ theme }) => ({
  marginTop: theme.spacing(9),
  marginBottom: theme.spacing(12),
  gap: theme.spacing(12),
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
  },
}));

export const StyledCopyLinkContainer = styled(Flex)(({ theme }) => ({
  backgroundColor: theme.palette.grey[100],
  borderRadius: theme.spacing(5),
  padding: theme.spacing(7),
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: theme.spacing(7),
  [theme.breakpoints.down('md')]: {
    width: '100%',
    gap: theme.spacing(5),
  },
}));

export const StyledCopyButton = styled(Button)(({ theme }) => ({
  width: 180,
  [theme.breakpoints.down('md')]: {
    width: 100,
  },
}));
